import * as storeTypes from './job-title.store-types';
import axios from 'axios';
import {JobTitle} from './job-title.models';

export default {
    namespaced: true,
    state: {
        isLoading: false,
        isActiveRequest: false,
        selectedJobTitle: new JobTitle,
        isModalVisible: false,
    },
    mutations: {
        [storeTypes.SET_SELECTED_JOB_TITLE]: (state, selectedJobTitle) => state.selectedJobTitle = selectedJobTitle,
        [storeTypes.SET_IS_MODAL_VISIBLE]: (state, isModalVisible) => state.isModalVisible = isModalVisible,
        [storeTypes.SET_IS_LOADING]: (state, isLoading) => state.isLoading = isLoading,
        [storeTypes.SET_IS_ACTIVE_REQUEST]: (state, isActiveRequest) => state.isActiveRequest = isActiveRequest,
    },
    actions: {
        async [storeTypes.ACTION_GET_JOB_TITLES](store, {companyId = ''}) {
            store.commit(storeTypes.SET_IS_LOADING, true);

            return new Promise((resolve, reject) => {
                (async () => {
                    try {
                        const {data: {success, error, jobTitles}} = await axios.get(`/api/companies/${companyId}/job-titles`);

                        if (!success) {
                            return reject(error);
                        }

                        resolve(jobTitles.map(jobTitle => JobTitle.fromArray(jobTitle)));
                    } catch ({response: {data: {error}}}) {
                        reject(error);
                    } finally {
                        store.commit(storeTypes.SET_IS_LOADING, false);
                    }
                })();
            });
        },
        async [storeTypes.ACTION_ADD_JOB_TITLE](store, {companyId, jobTitle}) {
            store.commit(storeTypes.SET_IS_ACTIVE_REQUEST, true);

            return new Promise((resolve, reject) => {
                (async () => {
                    try {
                        const {data: {success}} = await axios.post(`/api/companies/${companyId}/job-titles`, {jobTitle});

                        if (success) {
                            return resolve();
                        }
                    } catch ({response: {data: {error}}}) {
                        reject(error);
                    } finally {
                        store.commit(storeTypes.SET_IS_ACTIVE_REQUEST, false);
                    }
                })();
            });
        },
        async [storeTypes.ACTION_UPDATE_JOB_TITLE](store, {companyId, jobTitle}) {
            store.commit(storeTypes.SET_IS_ACTIVE_REQUEST, true);

            return new Promise((resolve, reject) => {
                (async () => {
                    try {
                        const {data: {success}} = await axios.put(`/api/companies/${companyId}/job-titles/${jobTitle._id}`, {jobTitle});

                        if (success) {
                            return resolve();
                        }
                    } catch ({response: {data: {error}}}) {
                        reject(error);
                    } finally {
                        store.commit(storeTypes.SET_IS_ACTIVE_REQUEST, false);
                    }
                })();
            });
        },
        async [storeTypes.ACTION_REMOVE_JOB_TITLE](store, {companyId, jobTitleId}) {
            store.commit(storeTypes.SET_IS_ACTIVE_REQUEST, true);

            return new Promise((resolve, reject) => {
                (async () => {
                    try {
                        const {data: {success}} = await axios.delete(`/api/companies/${companyId}/job-titles/${jobTitleId}`);

                        if (success) {
                            return resolve();
                        }
                    } catch ({response: {data: {error}}}) {
                        reject(error);
                    } finally {
                        store.commit(storeTypes.SET_IS_ACTIVE_REQUEST, false);
                    }
                })();
            });
        },
        async [storeTypes.ACTION_UPDATE_JOB_TITLE_OVP_JOB_CONDITIONS](store, {companyId, jobTitleId, selectedOvpJobConditions = []}) {
            store.commit(storeTypes.SET_IS_ACTIVE_REQUEST, true);

            return new Promise((resolve, reject) => {
                (async () => {
                    try {
                        const {
                            data: {success}
                        } = await axios.put(`/api/companies/${companyId}/job-titles/${jobTitleId}/ovp`, {selectedOvpJobConditions});

                        if (success) {
                            return resolve();
                        }
                    } catch ({
                        response: {
                            data: {error}
                        }
                    }) {
                        reject(error);
                    } finally {
                        store.commit(storeTypes.SET_IS_ACTIVE_REQUEST, false);
                    }
                })();
            });
        },
        async [storeTypes.ACTION_SHOW_MODAL](store, jobTitle = null) {
            if (jobTitle) {
                store.commit(storeTypes.SET_SELECTED_JOB_TITLE, JobTitle.fromArray(jobTitle));
            }

            store.commit(storeTypes.SET_IS_MODAL_VISIBLE, true);
        },
        async [storeTypes.ACTION_HIDE_MODAL](store) {
            store.commit(storeTypes.SET_SELECTED_JOB_TITLE, new JobTitle);
            store.commit(storeTypes.SET_IS_MODAL_VISIBLE, false);
        },
    },
    getters: {
        [storeTypes.GET_SELECTED_JOB_TITLE]: state => state.selectedJobTitle,
        [storeTypes.GET_IS_MODAL_VISIBLE]: state => state.isModalVisible,
        [storeTypes.GET_IS_LOADING]: state => state.isLoading,
        [storeTypes.GET_IS_ACTIVE_REQUEST]: state => state.isActiveRequest,
    },
}